import { useEffect, useState } from 'react';

import { useHiresToDate } from './context';

/** Matches the `hires-recount` keyframes in `tailwind.css`. */
const RECOUNT_TINT_MS = 600;

/** Tints a recounted value; reduced motion skips it. */
export const RECOUNT_TINT_CLASS =
  'motion-safe:animate-hires-recount rounded-sm';

/**
 * Whether values the Hires to date switch recounted have just appeared, so
 * they can carry a brief tint. It turns on once the values for the new switch
 * position are on screen, not while they still load, and off after the tint.
 */
export function useRecountTint(isRecounting: boolean): boolean {
  const { isOn } = useHiresToDate();
  const [shownFor, setShownFor] = useState(isOn);
  const [isTinting, setIsTinting] = useState(false);

  if (!isRecounting && shownFor !== isOn) {
    setShownFor(isOn);
    setIsTinting(true);
  }

  // Table cells remount on every render, so the class has to leave once the
  // tint ends or a later render would replay it.
  useEffect(() => {
    if (!isTinting) return;
    const timer = window.setTimeout(() => setIsTinting(false), RECOUNT_TINT_MS);
    return () => window.clearTimeout(timer);
  }, [isTinting]);

  return isTinting;
}
